module.exports = __webpack_public_path__ + "static/beholder-0693553bcce8a8a7299e13291414e1d8.jpg";